import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import styles from '../mortgage.module.scss';

interface ZipCodeData {
  error?: string;
  isCheckingZipCode: boolean;
  onClick: () => void;
  setZipCode: (string) => void;
  zipCode: string;
}

export const ZipCodeStep: React.FC<ZipCodeData> = ({ error, isCheckingZipCode, onClick, setZipCode, zipCode }) => {
  const canSubmit = zipCode.length === 5 && !isCheckingZipCode;

  return (
    <section className="step zip-code">
      <h2 className={`${styles.heading} mx-auto text-center font-bold`}>Where is this home?</h2>
      <div className="mx-auto mb-7 max-w-[440px] text-[15px] leading-normal text-slate-500">
        We use your zip code to match you with lenders licensed in your state.
      </div>
      <div className="mx-auto max-w-[240px] text-left">
        <label className="mb-1 block text-[13px] font-semibold text-bzblue-1000" htmlFor="zip_code">
          Zip Code
        </label>
        <input
          autoComplete="postal-code"
          className={styles.input}
          id="zip_code"
          inputMode="numeric"
          maxLength={5}
          name="zip_code"
          onChange={e => {
            if (/^\d{0,5}$/.test(e.target.value)) {
              setZipCode(e.target.value);
            }
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && canSubmit) onClick();
          }}
          placeholder="e.g. 60606"
          value={zipCode}
        />
        {error && <div className="mt-1 text-[13px] text-red-600">{error}</div>}
      </div>
      <button
        className={`${styles.cta} inline-flex items-center justify-center font-bold uppercase`}
        disabled={!canSubmit}
        onClick={onClick}
        type="button"
      >
        {isCheckingZipCode ? (
          <Icon icon={faSpinner} spin={true} />
        ) : (
          <>
            NEXT
            <span aria-hidden="true" className="text-base leading-none">
              &rarr;
            </span>
          </>
        )}
      </button>
    </section>
  );
};
